import userReducer from '@app/api/slices/userSlice';
import authReducer from '@app/api/slices/authSlice';
import nightModeReducer from '@app/api/slices/nightModeSlice';
import themeReducer from '@app/api/slices/themeSlice';
import pwaReducer from '@app/api/slices/pwaSlice';

export default {
  user: userReducer,
  auth: authReducer,
  nightMode: nightModeReducer,
  theme: themeReducer,
  pwa: pwaReducer,
};
